import api from "../../../api";

export class ComunicacaoMembroViewModel {

    static async convocaBanca(bancaId: string): Promise<any> {
        try {
            const response = await api.post(`/emails/convocacao/membros?bancaId=${bancaId}`);
            return response;
        } catch (error) {
            console.error('Erro ao convocar Banca:', error);
            throw error;
        }
    }
}